import React from "react";
import MainModel from "./MainModel";
import MaterialInitialiser from "../materials/MaterialInitialiser";

const MainModelManager = ({currMaterialRef, mat, props, geometries}) => {
  
  
  return (
    <>
      <group>
        
        {geometries.map((geom, index) => {
          
          return (
            <MainModel key={index} geom={geom} material={geom.material}/>
          )
          
        })}
      
      </group>
      
      {(currMaterialRef) && (<MaterialInitialiser activeMaterials={mat}/>)}
    
    </>
  )
  
};


export default MainModelManager;
